module.exports = __webpack_public_path__ + "assets/img/22_269_big.3508ed55.jpg";